export const ACTIVATION_REDIRECT_STORAGE_KEY = 'astra:pending-activation-redirect';

export function storePendingActivationRedirect(path) {
  try {
    if (typeof window === 'undefined' || !window.sessionStorage) return;
    const value = String(path || '').trim();
    if (!value || value === '/activate') return;
    window.sessionStorage.setItem(ACTIVATION_REDIRECT_STORAGE_KEY, value);
  } catch {
    // ignore
  }
}

export function consumePendingActivationRedirect() {
  try {
    if (typeof window === 'undefined' || !window.sessionStorage) return '';
    const value = window.sessionStorage.getItem(ACTIVATION_REDIRECT_STORAGE_KEY) || '';
    if (value) {
      window.sessionStorage.removeItem(ACTIVATION_REDIRECT_STORAGE_KEY);
    }
    return value;
  } catch {
    return '';
  }
}
